import React from 'react';
import { Link } from 'react-router-dom';
import { useSparks } from '../../contexts/SparksContext';
import { levelBadgeUrl } from './achievementRules';

/** Nav chip: the child's level badge at 28 px, linking to Achievements. Badge pop-ups fly here. */
export default function LevelChip() {
  const { enabled, level, levelThresholds } = useSparks();
  if (!enabled || !levelThresholds.length) return null;
  return (
    <Link
      to="/achievements"
      data-achievements-target
      title={`Level ${level} · Achievements`}
      aria-label={`Level ${level}. Open Achievements`}
      className="flex items-center gap-1 rounded-full bg-white/15 pl-1 pr-2 py-0.5 text-white text-sm font-semibold hover:bg-white/25"
    >
      <img src={levelBadgeUrl(level)} alt="" width={26} height={28} />
      <span>Lv {level}</span>
    </Link>
  );
}
